import type { ApiErrorResponse } from 'frontend-payments/utils/error-handler';

/**
 * Extracts error data from response and throws a structured error
 */
export async function throwApiError(response: Response): Promise<never> {
  const errorData = {
    detail: 'Unable to process the response from the server.',
    error: 'Response Error',
  };

  try {
    const data = (await response.json()) as {
      detail?: string;
      error?: string;
    };
    errorData.detail = data.detail || errorData.detail;
    errorData.error = data.error || errorData.error;
  } catch {
    // JSON parsing failed, keep default values
  }

  const error = new Error('API request failed');
  Object.assign(error, {
    status: response.status,
    data: errorData,
  } as ApiErrorResponse);

  throw error;
}
